import { render, staticRenderFns } from "./BaseCopyToClipboard.vue?vue&type=template&id=1c50b27e"
import script from "./BaseCopyToClipboard.vue?vue&type=script&lang=js"
export * from "./BaseCopyToClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports